import React from "react";
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  VisuallyHidden,
  FormControlProps,
  FormErrorMessageProps
} from "@chakra-ui/react";

interface InputLayoutProps extends Omit<FormControlProps, "label"> {
  label: React.ReactNode;
  labelHidden?: boolean;
  id: string;
  input: React.ReactElement;
  errorMessage?: string | null;
  errorProps?: FormErrorMessageProps;
}

const InputLayout: React.FC<InputLayoutProps> = ({
  id,
  label,
  labelHidden = false,
  input,
  errorMessage,
  errorProps,
  ...rest
}) => {
  return (
    <FormControl id={id} isInvalid={!!errorMessage} {...rest}>
      {label && labelHidden && <VisuallyHidden>{label}</VisuallyHidden>}
      {label && !labelHidden && (
        <FormLabel whiteSpace="nowrap" color="black">
          {label}
        </FormLabel>
      )}
      {input}
      <FormErrorMessage {...errorProps}>{errorMessage}</FormErrorMessage>
    </FormControl>
  );
};

export default InputLayout;
